<div class="picklist d-flex flex-column flex-md-row">
	<div class="picklist_left_panel flex-grow-1">
		<label
			><strong>{{ selectedListLabel }}</strong></label
		>

		<ul
			class="picklist_items"
			[attr.disabled]="disabled"
			#selectedListElement
		>
			<ng-template
				ngFor
				let-value
				let-index="index"
				[ngForOf]="selectedList"
			>
				<li
					class="picklist_item"
					(click)="togglePendingSelection(value)"
					(dblclick)="removeFromselectedList(value)"
					[class.picklist_item_selected]="pendingSelection[value.id]"
					[class.disabled-item]="disabled"
				>
					<ng-container
						*ngTemplateOutlet="
							pickListItem;
							context: { $implicit: value }
						"
					></ng-container>
				</li>
			</ng-template>
		</ul>
	</div>
	<div
		class="picklist_controls d-flex flex-row flex-md-column justify-content-around justify-content-md-center"
	>
		<button
			[disabled]="disabled"
			class="btn btn-primary picklist_control"
			(click)="addAllToSelectedList()"
			title="Adicionar todos"
		>
			<i class="d-block d-md-none bi bi-arrow-up"></i>
			<i class="d-block d-md-none bi-arrow-up"></i>
			<i class="d-none d-md-block bi bi-arrow-left"></i>
			<i class="d-none d-md-block bi bi-arrow-left"></i>
		</button>
		<button
			[disabled]="disabled"
			class="btn btn-primary picklist_control"
			(click)="addToSelectedList()"
			title="Adicionar selecionados"
		>
			<i class="d-block d-md-none bi-arrow-up"></i>
			<i class="d-none d-md-block bi bi-arrow-left"></i>
		</button>
		<button
			[disabled]="disabled"
			class="btn btn-primary picklist_control"
			(click)="removeFromselectedList()"
			title="Remover selecionados"
		>
			<i class="d-block d-md-none bi-arrow-down"></i>
			<i class="d-none d-md-block bi bi-arrow-right"></i>
		</button>
		<button
			[disabled]="disabled"
			class="btn btn-primary picklist_control"
			title="Remover todos"
			(click)="removeAllFromselectedList()"
		>
			<i class="d-block d-md-none bi bi-arrow-down"></i>
			<i class="d-block d-md-none bi-arrow-down"></i>
			<i class="d-none d-md-block bi bi-arrow-right"></i>
			<i class="d-none d-md-block bi bi-arrow-right"></i>
		</button>
	</div>
	<div class="picklist_right_panel flex-grow-1">
		<label
			><strong>{{ unselectedListLabel }}</strong></label
		>
		<ul
			class="picklist_items"
			[attr.disabled]="disabled"
			#selectedListElement
		>
			<ng-template
				ngFor
				let-value
				let-index="index"
				[ngForOf]="unselectedList"
			>
				<li
					class="picklist_item"
					(click)="togglePendingSelection(value)"
					(dblclick)="addToSelectedList(value)"
					[class.picklist_item_selected]="pendingSelection[value.id]"
					[class.disabled-item]="disabled"
				>
					<ng-container
						*ngTemplateOutlet="
							pickListItem;
							context: { $implicit: value }
						"
					></ng-container>
				</li>
			</ng-template>
		</ul>
	</div>
</div>
